import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { SvgIcon } from '../../../../components/Icon';
import { theme } from '../../../../styles/theme';

interface IButtonGetStartedLinkItem {
  type: 'button';
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

interface ILinkGetStartedLinkItem {
  type: 'link';
  label: string;
  url: string;
  isExternal?: boolean;
}

type IProps = IButtonGetStartedLinkItem | ILinkGetStartedLinkItem;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 24px;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: ${theme.colors.secondary900};
  transition: color 0.2s ease-in-out;
  &:hover {
    cursor: pointer;
    color: ${theme.colors.mainBlue};
  }
`;

const ComponentSvgIcon = () => (
  <SvgIcon
    name="arrow-up-right"
    width={24}
    height={24}
    customFill="currentColor"
  />
);

const GetStartedLinkItem = (props: IProps) => {
  if (props.type === 'button') {
    const { onClick, disabled, label } = props;

    return (
      <StyledLink
        as="button"
        type="button"
        onClick={onClick}
        disabled={disabled}
      >
        {label}
        <ComponentSvgIcon />
      </StyledLink>
    );
  }

  const { url, label, isExternal } = props;

  if (isExternal) {
    return (
      <StyledLink as="a" href={url} target="_blank" rel="noopener noreferrer">
        {label}
        <ComponentSvgIcon />
      </StyledLink>
    );
  }

  return (
    <StyledLink to={url}>
      {label}
      <ComponentSvgIcon />
    </StyledLink>
  );
};

export default GetStartedLinkItem;
